export class CompanyModel {
  companyId: string;
  companyName: string;
  description: string;
  registrationDate: Date;
  registeredBy: string;
  source: string;
  isActive: boolean;
  domain: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.companyId = '';
      this.companyName = '';
      this.description = '';
      this.registrationDate = new Date();
      this.registeredBy = '';
      this.source = '';
      this.isActive = false;
      this.domain = '';
    }
  }
}
